export const story = () => {
    const wrapper = document.querySelector('.story');

    if (!wrapper) {
        return;
    }

    const bar = wrapper.querySelector('.bar');
    const prog = wrapper.querySelector('.story__progress');
    const navNext = wrapper.parentNode.querySelector('.next');
    const navBack = wrapper.parentNode.querySelector('.back');
    const panels = wrapper.querySelectorAll('.story__main > div');

    const isMobile = () => window.matchMedia('(max-width: 1024px)').matches;

    let width = prog.offsetWidth;
    let isAnimating = false;

    let trackedPct = 0;
    const mobileScrollDuration = 600;

    const sizeProgress = () => {
        const main = wrapper.querySelector('.story__main');
        prog.style.width = (isMobile() && main) ? main.scrollWidth + 'px' : '';
    };

    const syncPanelVisibility = () => {
        const box = wrapper.getBoundingClientRect();
        panels.forEach(panel => {
            const rect = panel.getBoundingClientRect();
            panel.inert = Math.min(rect.right, box.right) - Math.max(rect.left, box.left) <= 0;
        });
    };

    const scrollMobileTo = (target) => {
        isAnimating = true;
        wrapper.scrollTo({ left: target, behavior: 'smooth' });

        setTimeout(() => {
            isAnimating = false;
        }, mobileScrollDuration);
    };

    sizeProgress();

    window.onresize = () => {
        sizeProgress();
        width = prog.offsetWidth;
        syncPanelVisibility();
    };

    // Add the smooth scroll function
    const smoothScroll = (element, target, duration) => {
        const start = element.scrollLeft;
        const change = target - start;
        const increment = 20;
        let currentTime = 0;

        const animateScroll = () => {
            currentTime += increment;
            const val = Math.easeInOutQuad(currentTime, start, change, duration);
            element.scrollLeft = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };

        animateScroll();
    };

    Math.easeInOutQuad = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    };

    // Function to handle the next navigation
    const handleNext = () => {
        if (isAnimating || navNext.getAttribute('aria-disabled') === 'true') return;

        if (isMobile()) {
            const slide = wrapper.clientWidth;
            const max = wrapper.scrollWidth - wrapper.clientWidth;
            const target = Math.min(Math.round(wrapper.scrollLeft / slide) * slide + slide, max);
            scrollMobileTo(target);
            return;
        }

        let goTo = 0;
        isAnimating = true;

        if (currentTracked < 2) {
            currentTracked += 1;
        }

        if (currentTracked == 1) {
            // Go to the end of story__three
            const storyThree = document.querySelector('.story__three');
            goTo = storyThree.offsetLeft + storyThree.offsetWidth - wrapper.clientWidth;
        } else if (currentTracked == 2) {
            // Go to the end of story__four (which should be the end of the scrollable area)
            const storyFour = document.querySelector('.story__four');
            goTo = storyFour.offsetLeft + storyFour.offsetWidth - wrapper.clientWidth;
        }

        // Ensure we don't scroll past the maximum scroll position
        const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
        goTo = Math.min(goTo, maxScroll);

        smoothScroll(wrapper, goTo, 3000);
        setPct();

        setTimeout(() => {
            isAnimating = false;
        }, 3100);
    };

    // Function to handle the back navigation
    const handleBack = () => {
        if (isAnimating || navBack.getAttribute('aria-disabled') === 'true') return;

        if (isMobile()) {
            const slide = wrapper.clientWidth;
            const target = Math.max(Math.round(wrapper.scrollLeft / slide) * slide - slide, 0);
            scrollMobileTo(target);
            return;
        }

        let goTo = 0;
        isAnimating = true;

        if (currentTracked > 0) {
            currentTracked -= 1;
        }

        if (currentTracked == 0) {
            // Go back to the beginning
            goTo = 0;
        } else if (currentTracked == 1) {
            // Go to the end of story__three
            const storyThree = document.querySelector('.story__three');
            goTo = storyThree.offsetLeft + storyThree.offsetWidth - wrapper.clientWidth;
        }

        // Ensure we don't go below 0
        goTo = Math.max(goTo, 0);
        
        smoothScroll(wrapper, goTo, 3000);
        setPct();

        setTimeout(() => {
            isAnimating = false;
        }, 3100);
    };

    // Add click event listeners
    navNext.addEventListener('click', handleNext);
    navBack.addEventListener('click', handleBack);

    // Add keyboard event listeners for accessibility
    navNext.addEventListener('keydown', (e) => {
        // Activate on Enter or Space
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            handleNext();
        }
    });

    navBack.addEventListener('keydown', (e) => {
        // Activate on Enter or Space
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            handleBack();
        }
    });
    
    const updateButtonState = () => {
        navNext.setAttribute('aria-disabled', String(trackedPct >= 100));
        navBack.setAttribute('aria-disabled', String(trackedPct <= 0));
    };
    
    // Update setPct function to include button state updates
    const setPct = () => {
        const offset = wrapper.scrollWidth - wrapper.clientWidth;
        const prog = (wrapper.scrollLeft / offset) * 100;

        let display = Math.ceil(prog);

        // Prevent 99.99%
        if (display >= 99) {
            display = 100;
        }

        bar.querySelector('span').innerText = `${display}%`;
        bar.style.width = prog + '%';
        
        trackedPct = display;
        
        // Update button states
        updateButtonState();
    };

    // Initialize buttons state
    setPct();
    syncPanelVisibility();

    wrapper.onscroll = () => {
        setPct();
        syncPanelVisibility();
        
        // Update currentTracked based on scroll position
        const scrollPos = wrapper.scrollLeft;
        const storyThree = document.querySelector('.story__three');
        const storyFour = document.querySelector('.story__four');
        
        // If we're at the beginning area
        if (scrollPos < storyThree.offsetLeft / 2) {
            currentTracked = 0;
        } 
        // If we're in the middle area (story__three)
        else if (scrollPos < storyFour.offsetLeft - storyFour.offsetWidth / 2) {
            currentTracked = 1;
        } 
        // If we're in the end area (story__four)
        else {
            currentTracked = 2;
        }
    };

    let currentTracked = 0;
};
